import { ScrollReveal } from "./ScrollReveal";

const media = [
  "Startup India",
  "Google News",
  "DailyHunt",
  "PropTech Buzz",
];

const FeaturedInSection = () => (
  <section className="section-white py-12 sm:py-16 border-y border-border/50">
    <div className="container mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <p className="text-center text-[10px] sm:text-xs font-medium uppercase tracking-[0.2em] mb-6 sm:mb-8 text-muted-foreground/60">
          Featured In
        </p>
      </ScrollReveal>
      <ScrollReveal>
        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-12">
          {media.map((name, i) => (
            <span
              key={i}
              className="text-base sm:text-lg font-semibold text-foreground/15 hover:text-foreground/40 transition-colors duration-300 cursor-default"
            >
              {name}
            </span>
          ))}
        </div>
      </ScrollReveal>
    </div>
  </section>
);

export default FeaturedInSection;
